import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import Spinner from '@/components/common/Spinner';
import Grid from '@/components/shared/NewLessonOverview/Cards/Grid';
import UnitCard from '../Cards/UnitCard';

interface UnitSectionProps {
  color: string;
  programId: number;
}

const UnitSection = ({ color, programId }: UnitSectionProps) => {
  const [loading, setLoading] = useState(true);
  const [units, setUnits] = useState([]);

  useEffect(() => {
    const route = Routes.plato_api_program_units_path(programId);

    axios.get(route)
      .then((response) => {
        setLoading(false);
        setUnits(response.data.data);
      });
  }, []);

  if (loading) return <Spinner className="center tw-pt-5" />;

  return (
    <div className="tw-px-2 card-2col:tw-px-[2rem] tw-pt-4">
      <div className="tw-flex tw-justify-center">
        <Grid className="tw-justify-center chromebook-plus:!tw-px-4 chromebook-plus:!tw-ml-0" tag="ul">
          {units.map(unit => (
            <UnitCard
              key={unit.id}
              color={color}
              programId={programId}
              unit={unit}
            />
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default UnitSection;
